module.exports = __webpack_public_path__ + "static/logo_white_transparent-a0281bb9a02724684701a92e47c583c8.png";